import React, { FC } from 'react';

import { Grid, Paper } from '@material-ui/core';

import LeaderboardFilter from '../../Common/LeaderboardFilter/LeaderboardFilter';
import ResultsTable from '../../Common/ResultsTable/ResultsTable';
import { AssignResultsProvider } from './Context/AssignResults.context';

const AssignResults: FC = () => (
  <AssignResultsProvider>
    <div className="assign-results">
      <Grid className="grid" container={true} spacing={0}>
        <Grid className="grid-item" item={true} xs={4}>
          <LeaderboardFilter />
        </Grid>

        <Grid className="grid-item" item={true} xs={8}>
          <Paper elevation={1} className="paper result-table-paper">
            <ResultsTable />
          </Paper>
        </Grid>
      </Grid>
    </div>
  </AssignResultsProvider>
);

export default AssignResults;
